import { makeAutoObservable } from 'mobx';
import { auth } from '@config/Firebase';

export default class ApplicationStore {
  entities;

  constructor(rootStore) {
    this.rootStore = rootStore;
    this.entities = {};
    makeAutoObservable(this);
  }

  singInWithEmailAndPassword = async ({ email, password }) => {
    const userInfo = await auth
      .signInWithEmailAndPassword(email, password)
      .then(res => res.user)
      .catch(err => false);
    if (userInfo) {
      this.entities = { userInfo: userInfo };
      return true;
    } else {
      return false;
    }
  };

  setUserInfo = userInfo => {
    this.entities = { userInfo: userInfo };
  };

  logout = () => {
    this.entities = {};
  };
}
